export const SFCC_ORDER_STATUS = {
  awaiting_shipment: 'Awaiting Shipment',
  being_crafted: 'Being Crafted',
  partially_shipped: 'Partially Shipped',
  shipped: 'Shipped',
  ready_to_collect: 'Ready to Collect',
  partially_ready_to_collect: 'Partially Ready to Collect',
  preparing: 'Preparing',
  collected: 'Collected',
  cancelled: 'Cancelled',
  completed: 'Completed',
}

export const SHIPPING_STATUS = {
  awaiting_shipment: 'Awaiting Shipment',
  being_crafted: 'Being Crafted',
  not_shipped: 'Not Shipped',
  shipped: 'Shipped',
  cancelled: 'Cancelled',
  payment_pending: 'Payment Pending',
  being_processed: 'Being Processed',
  partially_shipped: 'Partially Shipped',
  click_collect: 'Click & Collect',
  ready_to_collect: 'Ready to Collect',
  partially_ready_to_collect: 'Partially Ready to Collect',
  preparing: 'Preparing',
  collected: 'Collected',
  completed: 'Completed',
  shipped_to_store: 'Shipped to Store',
}

export const LINE_ITEM_STATUS = {
  open_order: 'OpenOrder',
  delivered: 'Delivered',
  invoiced: 'Invoiced',
  cancelled: 'Cancelled',
}

export const SALES_ORDER_STATUS = {
  open_order: 'OpenOrder',
  invoiced: 'Invoiced',
  cancelled: 'Cancelled',
}

export const STOCK_REQUEST_CODE = {
  special_order: 'SRV-SpecialOrder',
}

export const PICKUP_DELIVERY_MODE = 'PICKUP'

export const CLICK_AND_COLLECT_ID = 'Click_and_Collect'

export const CLICK_AND_COLLECT_STATUS = {
  none: 'None',
  packed: 'Packed',
  invoiced: 'Invoiced',
}

/*
This object defines the available order statuses within Commestri.
It serves as a reference for the statuses that can be selected in the SFCC business manager.
Note: Not all statuses may be actively used in the current implementation.
*/
export const COMMESTRI_ORDER_STATUS = {
  pending: 'pending',
  initial: 'initial',
  modified: 'modified',
  pending_approval: 'pending_approval',
  accepted: 'accepted',
  partially_accepted: 'partially_accepted',
  rejected: 'rejected',
  awaiting_shipment: 'awaiting_shipment',
  partially_shipped: 'partially_shipped',
  shipped: 'shipped',
  cancelled: 'cancelled',
  refunded: 'refunded',
  completed: 'completed',
}

export const DELIVERY_METHOD = {
  'apost-sfs': 'standard_shipping',
  'bespo-prem': 'premium_shipping',
  'couri-ex': 'express_post',
  'dhl-ex': 'standard_shipping',
  'dhl-i-int': 'express_international_shipping',
  'dhl-s-exp': 'express_shipping',
  'dhl-z-ex': 'international_shipping',
  'din-ex': 'express_shipping',
  'eparc-st': 'standard_shipping',
  'ep-ex': 'express_shipping',
  'fedex-ipd': 'standard_shipping',
  'fedex-pr': 'express_shipping',
  'fedex-sfs': 'standard_shipping',
  'nzpos-sfs': 'standard_shipping',
  pickup: 'click_and_collect',
  'toll-pr': 'standard_shipping',
  'cdap-ex': 'express_shipping',
  'cdap-st': 'standard_shipping',
  'expre-ex': 'express_shipping',
  'stand-st': 'standard_shipping',
  'ups-exp': 'express_shipping',
  'ups-exps': 'express_shipping',
  'ups-std': 'standard_shipping',
  eparcel: 'standard_shipping',
  startrack_local: 'express_shipping',
  cashipping: 'standard_shipping',
  caexpressshipping: 'express_shipping',
  fedex_international: 'standard_shipping',
  standard: 'standard_shipping',
}

export const SHIPPING_METHOD_IDS = {
  e_parcel: 'eParcel',
  startrack_local: 'Startrack_Local',
  ca_express_shipping: 'CAExpressShipping',
  international: 'International',
  ca_shipping: 'CAShipping',
  fedex_international: 'Fedex_International',
  standard: 'Standard',
}

// Shared by the My Bag express label and Braze fulfilment rules.
export const EXPRESS_SHIPPING_METHOD_IDS = [
  SHIPPING_METHOD_IDS.startrack_local,
  SHIPPING_METHOD_IDS.ca_express_shipping,
]

// Methods hidden from the My Bag shipping list. Apple Pay express lives on My Bag, so it
// excludes the same set — the sheet must never offer a method the customer can't pick there.
export const MY_BAG_EXCLUDED_SHIPPING_METHOD_IDS = [
  SHIPPING_METHOD_IDS.startrack_local,
  SHIPPING_METHOD_IDS.international,
  SHIPPING_METHOD_IDS.ca_express_shipping,
]

// Carrier-named methods presented to the customer under one generic localised label. Shared so the
// My Bag list and the Apple Pay express sheet can't drift apart.
export const GENERIC_DELIVERY_SHIPPING_METHOD_IDS = [
  SHIPPING_METHOD_IDS.e_parcel,
  SHIPPING_METHOD_IDS.ca_shipping,
  SHIPPING_METHOD_IDS.fedex_international, // TODO: Remove post NZDC go-live
  SHIPPING_METHOD_IDS.standard,
]
